export const SET_ACTIVE_PRECINCT_ID = 'SET_ACTIVE_PRECINCT_ID';
